import React, {useContext} from 'react';
import UserImage from "./user-image.jsx";
import {AgentContext} from "../context/agent-context.jsx";
import {Card} from "../../../../../components/card/card.jsx";
import Alert from "../../../../../components/alert/alert.jsx";

const Tabs = ({tabSelected, setTabSelected, hasGeneralRequiredError = false}) => {
    const {changes, tabs} = useContext(AgentContext)

    return (
        <>
            <UserImage/>
            <Card className={"flex-1 min-h-0 flex flex-col"}>
                <Card.Body className={"flex-1 min-h-0 flex flex-col gap-2"}>
                    <div className={"grid grid-cols-12 gap-4 flex-1 min-h-0"}>
                        <div className={"col-span-12 h-full overflow-auto"}>
                            {tabs
                                .filter(tab => tab.label)
                                .map(({key, label}) => {
                                    const keyFind = changes.includes(key);

                                    return (
                                        <p key={key} className={`box-border cursor-pointer mb-[3px] last:mb-0 py-[2px] px-[5px] rounded-[3px] hover:bg-[#d3d3d3] active:bg-[#d3d3d3] ${tabSelected === key ? "bg-[#d3d3d3]" : ""} ${key === "general" && hasGeneralRequiredError ? "border border-[#dc2626]" : ""}`} onClick={() => setTabSelected(key)}>
                                            {label} <span className="ms-1">{keyFind ? "*" : ""}</span>
                                        </p>
                                    );
                                })}
                        </div>
                    </div>
                    {
                        changes.length > 0 &&
                        <Alert target={"warning"}>
                            <span className={"text-[14px]"}>* Salve suas alterações antes de sair</span>
                        </Alert>
                    }
                </Card.Body>
            </Card>
        </>
    );
};

export default Tabs;